import { appSettings } from 'AppSettings';
import { Typography, useTheme } from '@mui/material';
import useAuth from 'auth/UseAuth';
import React, { useCallback } from 'react';
import { CohortType } from 'data/ResearchProjectCohortData';
import { BaseDownloadFile } from '../../data/BaseData';
import { DownloadButton } from '../../components/DownloadButton';

export interface Props {
  researchProjectId: string;
  cohortType: CohortType;
  useDecryptedHashes: boolean;
}

export const ResearchProjectCohortExportButton = ({ researchProjectId, cohortType }: Props) => {
  const { accessToken } = useAuth();
  const theme = useTheme();

  const downloadData = useCallback(async () => {
    const cohort = cohortType === 'patient' ? 'Patients' : 'Samples';
    const url = `${appSettings.api.endpoint}/api/v2/ResearchProjectCohort/${researchProjectId}/${cohort}`;
    await BaseDownloadFile(url, accessToken);
  }, [accessToken, researchProjectId, cohortType]);

  return (
    <DownloadButton
      id='research-project-cohort-export-button'
      downloadData={downloadData}
      sx={{
        color: theme.colors.alpha.black[100],
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <Typography variant='button' ml={1}>{`Export ${cohortType === 'patient' ? 'Patients' : 'Samples'}`}</Typography>
    </DownloadButton>
  );
};
